export default "<div>{{ GetArticleType(id) }}</div>";